"use strict";

exports.__esModule = true;
exports.getColorField = getColorField;

var _ = require("../..");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const defaultProps = {
  defaultFormData: "",
  defaultOptions: {},
  defaultSchema: {
    "type": "string",
    "format": "color",
    "enum": ["black", "white"],
    "default": "black"
  }
};

const getSchema = props => {
  const schema = props.schema,
        defaultSchema = props.defaultSchema;
  let format;

  if (schema.type === "textColor") {
    format = "textColor";
  } else {
    format = "color";
  }

  return _extends({}, schema, {
    "type": "string",
    "format": format,
    "enum": schema.enum || ["black", "white"],
    "default": schema.default || "black"
  });
};

function getUiSchema(props) {
  const schema = props.schema,
        uiSchema = props.uiSchema,
        defaultOptions = props.defaultOptions;
  let options = (0, _.getUiOptions)(uiSchema);
  return {
    "ui:options": _extends({}, defaultOptions, {}, options)
  };
}

function getFormData(props) {
  let formData = props.formData,
      defaultFormData = props.defaultFormData;
  return formData;
}

function getColorField(props) {
  props = _extends({}, defaultProps, {}, props);
  const schema = getSchema(props);
  const uiSchema = getUiSchema(_extends({}, props, {
    schema: schema
  }));
  const formData = getFormData(_extends({}, props, {
    schema: schema,
    uiSchema: uiSchema
  }));
  return _extends({}, props, {
    schema: schema,
    uiSchema: uiSchema,
    formData: formData
  });
}